import { createContext, useContext } from 'react';

/**
 * Context for determining if the consuming app allows actions to be taken on cards
 *
 * This is introduced to work along with IsEmbeddedContext to allow the consuming app to override existing IsEmbedded behaviour,
 * without introducing breaking changes to various consumers.
 *
 * TODO: Refactor existing IsEmbeddedContext into this implementation
 */

export const IsEmbeddedContextV2 = /*#__PURE__*/createContext({
  allowActions: false,
  openLinkExternal: false
});
export const useIsEmbeddedContextV2 = () => useContext(IsEmbeddedContextV2);